<template>
  <v-card flat pa-0 ma-0>
    <v-card-title
      class="subheading black--text text-uppercase"
      pa-0
      ma-0
      v-if="$mq != 'mobile'"
    >
      &nbsp; &nbsp; Company
      <v-spacer />
      <v-btn v-if="false"  @click="generate" small color="blue" outline
        >Generate API / Secret Key</v-btn
      >&nbsp;
      <v-btn :loading="loading" @click="submit" small color="blue" outline
        >Save</v-btn
      >
      &nbsp;
      <v-btn icon
        ><v-icon @click="$emit('closeDialog',true)" small>close</v-icon></v-btn
      >
    </v-card-title>
    <v-card-title
      class="subheading black--text text-uppercase"
      pa-0
      ma-0
      v-if="$mq == 'mobile'"
    >
      &nbsp; &nbsp; Company
      <v-spacer />

      <v-btn :loading="loading" @click="submit" small color="blue" outline
        >Save</v-btn
      >
      &nbsp;
      <v-btn icon
        ><v-icon @click="$emit('closeDialog', true)" small>close</v-icon></v-btn
      >

      <v-btn @click="generate" small color="blue" outline
        >Generate API / Secret Key</v-btn
      >&nbsp;
    </v-card-title>
    <v-snackbar
      v-model="showSnackBar"
      style="margin: auto; color: #2b2f8e"
      color="white"
      class="mt-5"
      top
    >
      Profile Saved
    </v-snackbar>
    <v-divider />
    <v-card-text>
      <v-form v-model="valid">
        <v-layout class="pa-1">
          <v-flex xs2 :xs3="$mq == 'mobile'" pt-2>
            <span @click="saveBtn = true">
              <ImageCard
                :documentId="company.logo_profile_id"
                :keyId="company.id"
                height="48px"
                size="large"
                width="48px"
                v-on:imageChanged="updateLogo"
              />
            </span>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex sm12 class="field text-xs-left">
                <strong>Name</strong>
                <br />
                <br />
                <v-text-field
                  class="mr-2"
                  v-validate="'required'"
                  data-vv-name="name"
                  type="text"
                  outline
                  single-line
                  :error-messages="errors.collect('name')"
                  v-model="company.name"
                  required
                  @click="saveBtn = true"
                />
              </v-flex>
              <v-flex sm6 class="field text-xs-left">
                <strong>First line of Address </strong>
                <br />
                <br />
                <v-text-field
                  class="mr-2"
                  data-vv-name="address1"
                  type="text"
                  outline
                  single-line
                  :error-messages="errors.collect('address1')"
                  v-model="company.address1"
                  @click="saveBtn = true"
                />
              </v-flex>
              <v-flex sm6 class="field text-xs-left">
                <strong>Second line of Address</strong>
                <br />
                <br />
                <v-text-field
                  class="mr-2"
                  data-vv-name="address2"
                  type="text"
                  outline
                  single-line
                  :error-messages="errors.collect('address2')"
                  v-model="company.address2"
                  @click="saveBtn = true"
                />
              </v-flex>
              <v-flex sm6 class="field text-xs-left">
                <strong>City</strong>
                <br /><br />
                <v-text-field
                  class="mr-2"
                  data-vv-name="city"
                  type="text"
                  outline
                  single-line
                  :error-messages="errors.collect('city')"
                  v-model="company.city"
                  @click="saveBtn = true"
                />
              </v-flex>
              <v-flex sm6 class="field text-xs-left">
                <strong>zip</strong>
                <br /><br />
                <v-text-field
                  class="mr-2"
                  data-vv-name="zip"
                  type="text"
                  outline
                  single-line
                  :error-messages="errors.collect('zip')"
                  v-model="company.zip"
                  @click="saveBtn = true"
                />
              </v-flex>

              <v-flex sm6 class="field text-xs-left">
                <span @click="saveBtn = true">
                  <CountryList
                    :country="company.country_id"
                    v-on:countrySelected="countrySelected"
                  />
                </span>
              </v-flex>
              <v-flex sm6 class="field text-xs-left">
                <span @click="saveBtn = true">
                  <StateList
                    :countryId="company.country_id"
                    :state="company.state_id"
                    v-on:stateSelected="stateSelected"
                  />
                </span>
              </v-flex>

              <v-flex v-if="false" xs6 pt-3 class="field text-xs-left">
                <strong>Api Key</strong>
                <br />
                <v-text-field
                  class="mr-2"
                  v-validate="'required' || 'erp_profile.shared_secrect'"
                  data-vv-name="erp_profile.api_key"
                  type="text"
                  outline
                  single-line
                  :error-messages="errors.collect('erp_profile.api_key')"
                  v-model="erp_profile.api_key"
                  required
                  @click="saveBtn = true"
                />
              </v-flex>
              <v-flex xs6 pt-3 v-if="false" >
                <strong>Shared Secret</strong>
                <br />
                <v-text-field
                  class="style-input mr-2"
                  v-validate="'required' || 'erp_profile.shared_secrect'"
                  data-vv-name="erp_profile.shared_secrect"
                  type="text"
                  outline
                  single-line
                  :error-messages="errors.collect('erp_profile.shared_secrect')"
                  v-model="erp_profile.shared_secrect"
                  required
                />
              </v-flex>
              <v-flex xs6 class="field text-xs-left">
                <strong>Image Width</strong>
                <br />
                <br />
                <v-text-field
                  class="mr-2"
                  v-validate="'required' || 'erp_profile.imageSize'"
                  data-vv-name="erp_profile.imageSize"
                  type="text"
                  outline
                  single-line
                  :error-messages="errors.collect('erp_profile.imageSize')"
                  v-model="erp_profile.imageSize"
                  required
                />
              </v-flex>
              <v-flex xs6 class="field text-xs-left">
                <strong>URL</strong>
                <br />
                <br />
                <v-text-field
                  class="mr-2"
                  v-validate="'required' || 'erp_profile.url'"
                  data-vv-name="erp_profile.url"
                  type="text"
                  outline
                  single-line
                  :error-messages="errors.collect('erp_profile.url')"
                  v-model="erp_profile.url"
                  required
                />
              </v-flex>
              <v-flex xs12 class="field text-xs-left" pt-2>
                <strong>Database String </strong>
                <br />
                <br />
                <v-textarea
                  rows="3"
                  outline
                  v-validate="'required' || 'erp_profile.db_connection_string'"
                  data-vv-name="erp_profile.db_connection_string"
                  :error-messages="
                    errors.collect('erp_profile.dbString')
                  "
                  v-model="erp_profile.dbString"
                >
                </v-textarea>
              </v-flex>

              <v-flex sm12 pt-1>
                <div class="form-btn2"></div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card-text>
  </v-card>
</template>
<script>
import CompanyModel from "@/api/service/CompanyService";
import CountryList from "@/components/CountryList.vue";
import StateList from "@/components/StateList.vue";
import ImageCard from "@/components/ImageCard.vue";
const uuidv1 = require("uuid/v1");
export default {
  $_veeValidate: {
    validator: "new",
  },
  props: ["parameters"],
  components: {
    CountryList,
    StateList,
    ImageCard,
  },
  data() {
    return {
      company: {
        // erp_profile: {
        //   api_key:"",
        //   shared_secrect:"",
        //   url:"",
        //   db_connection_string:""
        // },
      },
       erp_profile: {
          api_key:"",
          imageSize:"",
          shared_secrect:"",
          url:"",
          db_connection_string:""
        },
      saveCard: true,
      valid: true,
      loading: false,
      showSnackBar: false,
      saveBtn: false,
      active: [
        { id: 0, name: "Active" },
        { id: 1, name: "Inactive" },
      ],
      authTypes: [
        { id: "TB", name: "Tibura" },
        { id: "LD", name: "Ldap" },
        { id: "GO", name: "Gmail" },
        { id: "36", name: "Office 365" },
      ],
    };
  },
  created: function () {
    if (this.parameters.id) {
      var $data = {};
      $data = this.parameters;
      this.company = $data;
      this.erp_profile = $data.erp_profile?   JSON.parse($data.erp_profile) : this.erp_profile;
    } else {
      this.generate();
    }
  },
  mounted: function () {},
  methods: {
    async generate() {
      this.erp_profile.api_key = uuidv1();
      this.erp_profile.shared_secrect = uuidv1();
      this.$forceUpdate();
    },
    countrySelected($id) {
      this.company.country_id = $id;
      this.$forceUpdate();
    },
    stateSelected($id) {
      this.company.state_id = $id;
    },
    editorChanged($description) {
      this.company.description = $description;
      //alert($description)
    },
    setcompanies($company) {
      this.company = $company[0];
      console.log(this.company);
    },

    validate() {
      this.valid = true;
    },
    submit() {
      this.$validator.validateAll();
      this.validate();
      console.log(this.valid);
      if (this.valid) {
        var navigate = this.$router;
        var stores = this.$store;
        this.company.erp_profile =  this.erp_profile ? JSON.stringify(this.erp_profile) : this.erp_profile;
        this.loading = true;
        if (this.company.id) {
          CompanyModel.save(this.company)
            .then((response) => {
              this.showSnackBar = true;
              this.loading = false;
              this.$emit("closeDialog", true);
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          CompanyModel.create(this.company)
            .then((response) => {
              this.showSnackBar = true;
              this.loading = false;
              this.$emit("closeDialog", true);
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
    },
    async updateLogo($image) {
      this.company.logo_profile_id = $image.id;
      this.$forceUpdate();
      // await CompanyModel.save({"id":this.company.id,logo_profile_id:$image.id})
    },
    validatePortal() {
      CompanyModel.validate(this.company);
    },
  },
};
</script>

<style  >
.style-input {
  padding: 0px;
  margin: 0px;
  width: 100%;
}
.style-input1 {
  justify-content: center;
}
</style>
